import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import AgentPortalError from 'errors/AgentPortalError';
import { UPDATE_PASSENGER_SEATS } from 'store/mutations';

const UpdatePassengerSeatsMutation = ({ onCompleted, children, isNewBooking, isOnHold }) => {
  const [updatePassengerSeats, { error, loading }] = useMutation(UPDATE_PASSENGER_SEATS(isNewBooking || isOnHold), {
    onCompleted,
    refetchQueries: ['getSeatingData']
  });

  if (error) {
    throw new AgentPortalError(error);
  }

  const handleUpdateSeats = (bookingReference, seatsToUpdate) => {
    if (seatsToUpdate.length > 0) {
      return updatePassengerSeats({
        variables: {
          seats: seatsToUpdate,
          reference: bookingReference
        }
      });
    }

    if (onCompleted) {
      return onCompleted();
    }

    return null;
  };

  return children(handleUpdateSeats, { loading });
};

UpdatePassengerSeatsMutation.propTypes = {
  children: PropTypes.func.isRequired,
  onCompleted: PropTypes.func,
  isNewBooking: PropTypes.bool,
  isOnHold: PropTypes.bool
};

export default UpdatePassengerSeatsMutation;
